import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import * as Utils from '../../utils/Utils';
import rgbPaymentsAuthsService from '../../services/3rd/rgb/rgbPaymentsAuths.service';
import rgbPaymentsBasketsService from '../../services/3rd/rgb/rgbPaymentsBaskets.service';
import LoadingProgressBar from '../UI/LoadingProgressBar';
import { ErrorRoutes, RoutesUrl } from '../../constants/routes.constants';

const SignCancel = (props) => {
  const { history, t } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [seconds, setSeconds] = useState(5);

  const timerRef = useRef(null);
  const closeTimeoutRef = useRef(null);
  const actionRef = useRef(null);

  const countDown = useCallback(() => {
    setSeconds((prev) => {
      const next = prev - 1;

      if (next <= 0) {
        clearInterval(timerRef.current);
        return 0;
      }

      return next;
    });
  }, []);

  const autoRedirectAfterCountdown = useCallback(() => {
    timerRef.current = setInterval(countDown, 1000);

    closeTimeoutRef.current = setTimeout(() => {
      const state = Utils.getParameterByName('state');
      if (state) {
        return history.push(state);
      }

      const router = Utils.rebuildRouterUrl(RoutesUrl.PaymentList);
      return history.push(router);
    }, 5000);
  }, [countDown, history]);

  const getBasketUUID = useCallback(async () => {
    const basketUUID = Utils.getParameterByName('basketUUID');

    if (!basketUUID) {
      return null;
    }

    const { success, data } = await rgbPaymentsBasketsService.getByBasketUUID({ basketUUID });

    if (!success || !data?.length) {
      return null;
    }

    return basketUUID;
  }, []);

  const updateVoucherPayments = useCallback(async () => {
    const basketUUID = await getBasketUUID();

    if (!basketUUID) {
      history.push(ErrorRoutes.Notfound);
      return;
    }

    setIsLoading(true);

    try {
      const authParam = {
        basketUUID,
        statusText: 'CANCELED',
        statusID: 4001,
      };

      const res = await rgbPaymentsAuthsService.updateByBasketUUID(authParam);
      const { success: successRes } = res;

      if (successRes) {
        autoRedirectAfterCountdown();
      } else {
        history.push(ErrorRoutes.Notfound);
      }
    } finally {
      setIsLoading(false);
    }
  }, [getBasketUUID, history, autoRedirectAfterCountdown]);

  const handleSignantAuthProcess = useCallback(async () => {
    return false;
  }, []);

  useEffect(() => {
    const action = Utils.getParameterByName('action');
    actionRef.current = action;

    switch (action) {
      case 'signant-auth':
        handleSignantAuthProcess();
        break;
      case 'payment-auth':
        updateVoucherPayments();
        break;
      default:
        history.push(ErrorRoutes.Notfound);
        break;
    }
  }, [history, handleSignantAuthProcess, updateVoucherPayments]);

  useEffect(() => {
    return () => {
      clearInterval(timerRef.current);
      clearTimeout(closeTimeoutRef.current);
    };
  }, []);

  return (
    <div>
      <div
        className="row"
        style={{
          height: '100vh',
          display: 'flex',
          minWidth: '30%',
        }}
      >
        <div
          className="col s12 text-center"
          style={{
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <span className="red-text">{t('text-cancel')}</span>
          <div
            style={{
              minHeight: '24px',
              opacity: !isLoading && seconds > 0 && seconds <= 5 ? 1 : 0,
              transition: 'opacity 0.4s ease',
            }}
          >
            ({seconds})
          </div>
          <LoadingProgressBar loading={isLoading} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

export default withRouter(connect(mapStateToProps)(withNamespaces('signCancel')(SignCancel)));
